import { create, METHOD } from '../utils'

export default {
    login: ({account, password}) => create({
        url: "/egg/user/login",
        method: METHOD.POST
    })({account, password}),
    register: user => {
        const {account, password} = user;
        if (!account || !password) throw new Error("缺少必要参数！")
        return create({
            url: "/egg/user/register",
            method: METHOD.POST
        })(user)
    },
}